import { formatCurrency } from '../format/format';

/** "3" / "3.4" / "20" — one decimal under 10, whole from 10; no trailing ".0". */
export function formatUsualRatio(ratio) {
  const r = Number(ratio);
  if (!Number.isFinite(r)) return '';
  if (r >= 10) return String(Math.round(r));
  return String(Math.round(r * 10) / 10);
}

/**
 * ONE line of copy for a `comparePriceToUsual` result (KAN-1061). Pure: takes
 * `intl`, imports no react-intl. Returns null when there is nothing to say.
 */
export function priceVsUsualText(intl, result) {
  if (!result) return null;
  if (result.kind === 'aboveUsual') {
    return intl.formatMessage(
      { id: 'money.priceWarning.aboveUsual', defaultMessage: '{ratio}× usual · usual {usual}' },
      { ratio: formatUsualRatio(result.ratio), usual: formatCurrency(result.usual) },
    );
  }
  if (result.kind === 'belowUsual') {
    return intl.formatMessage(
      { id: 'money.priceWarning.belowUsual', defaultMessage: 'Well below usual · usual {usual}' },
      { usual: formatCurrency(result.usual) },
    );
  }
  if (result.kind === 'aboveFlat') {
    return intl.formatMessage(
      { id: 'money.priceWarning.aboveFlat', defaultMessage: 'High amount · over {flat}' },
      { flat: formatCurrency(result.flat) },
    );
  }
  return null;
}
